import axios from "axios";
import { apiActiveURL, appId, appKey } from "../../ApiBaseURL";

export const HandleFocus = (status) => {
  return (dispatch) => {
    dispatch({ type: "FOCUS_HANDLE", payload: status });
  };
};
